import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-85a44ef6")

_pushScopeId("data-v-85a44ef6")
const _hoisted_1 = {
  class: "container popup-container",
  id: "create-time-duration"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row edit-row" }
const _hoisted_4 = { class: "editing-title" }
const _hoisted_5 = { class: "row edit-row" }
const _hoisted_6 = { class: "editing-wrapper" }
const _hoisted_7 = { class: "col-12 text-lg-center" }
const _hoisted_8 = { class: "product-title" }
const _hoisted_9 = { class: "product-text text-lg-center" }
const _hoisted_10 = { class: "col-12 close-all-content text-center" }
const _hoisted_11 = {
  class: "product-title",
  style: {"margin-inline-end":"12px"}
}
const _hoisted_12 = { class: "edit-mode row" }
const _hoisted_13 = {
  class: "col-1",
  style: {"padding-inline-end":"4px"}
}
const _hoisted_14 = {
  class: "week-day p-0",
  style: {"margin-inline-end":"12px"}
}
const _hoisted_15 = {
  key: 0,
  class: "col-9 d-flex",
  style: {"padding-inline-start":"40px"}
}
const _hoisted_16 = {
  class: "col-12 col-sm-10 mx-auto",
  style: {"margin-top":"10px"}
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-8 col-md-6" }
const _hoisted_19 = { class: "product-title" }
const _hoisted_20 = { class: "product-text mb-0" }
const _hoisted_21 = {
  class: "col-4 col-md-6 p-start-0",
  style: {"text-align":"end"}
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "delete-image" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-trash fs-20" })
], -1)
const _hoisted_23 = { class: "delete-word" }
const _hoisted_24 = { class: "row edit-row popup-two-buttons" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("p", null, _toDisplayString(_ctx.$t('moreOption.moreOptionFor')) + " " + _toDisplayString($setup.workingDate.name), 1)
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('moreOption.closeTheDay')), 1),
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('moreOption.closeDayWithoutDeletingSlots')), 1)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('moreOption.closeAllDays')), 1),
            _createVNode("input", {
              id: "closeAllDays",
              type: "checkbox",
              class: "toggle",
              checked: !$setup.hasAnyActiveTimeSlot,
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.switchAllDays($event)))
            }, null, 8, ["checked"])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.weekNames, (weekname, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "col-sm-7 week-day-content mx-auto",
              key: index + weekname
            }, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", {
                      class: ["week-name", $setup.findCheckedWeekDay(weekname) ? 'active' : '']
                    }, _toDisplayString(_ctx.$t('weekday.' + weekname.substring(0, 2).toLowerCase())), 3)
                  ])
                ]),
                ($setup.findCheckedWeekDay(weekname))
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("input", {
                        id: `${weekname}-toggler`,
                        type: "checkbox",
                        class: "toggle little-toggle",
                        checked: $setup.findActiveWeekDay(weekname),
                        onClick: ($event: any) => ($setup.switchDay(weekname, $event))
                      }, null, 8, ["id", "checked", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('moreOption.deleteTheCalendar')), 1),
                _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('moreOption.theCalendarAndItsSlots')), 1)
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("button", {
                  class: "remove-button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.deleteWorkingDate && $setup.deleteWorkingDate(...args))),
                  type: "button"
                }, [
                  _hoisted_22,
                  _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('button.delete')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, [
          _createVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.save())),
            class: "save-button-wrapper popup-bookit-button w-100",
            type: "button"
          }, _toDisplayString(_ctx.$t('button.save')), 1)
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("button", {
            class: "close-button-wrapper popup-bookit-button w-100",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
            type: "button"
          }, _toDisplayString(_ctx.$t('button.close')), 1)
        ])
      ])
    ])
  ]))
})